import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InlineLoader from "../../../components/atoms/inlineLoader";
import WYWSGI from "../../../components/atoms/wywsgi";
import { useStore } from "../../../store";
import Axios from "../../../AxiosConfig";
const NewSupport = () => {
    const { layoutStore } = useStore();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const raiseTicket = async () => {
        setLoading(true);
        if (subject.length === 0 || subject.length > 200) {
            layoutStore.showToaster(
                "Subject must be between 1 and 200 characters",
                "error"
            );
            setLoading(false);
            return;
        }
        Axios.post("/support/create", {
            subject,
            message: JSON.stringify(message),
        }).then((res) => {
            if (res.data.success) {
                layoutStore.showToaster("Ticket raised successfully", "success");
                navigate("/support");
            } else {
                layoutStore.showToaster(res.data.error, "error");
                setLoading(false);
            }
        });

    };
    const goBackButton = () => {
        navigate('/support')
    }

    return (
        <>
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <div className="bg-white py-8 px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-left">
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                        Employer Support Center
                    </h2>
                    <p className="mt-4 text-lg leading-8 text-gray-600">
                        Your platform to report changes, raise queries, and connect with the admin team.
                    </p>
                    <div className="mt-6">
                        <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                            Issue Summary
                        </label>
                        <div className="mt-1">
                            <input
                                type="text"
                                name="subject"
                                id="subject"
                                onChange={(e) => setSubject(e.target.value)}
                                className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                placeholder="Briefly describe your issue or query here in a few words."
                                aria-describedby="subject-description"
                            />
                        </div>
                        <p className="mt-2 text-sm text-gray-500" id="subject-description">
                            Be specific and concise
                        </p>
                    </div>
                    <div className="mt-6 focus:border-blue-500 focus:ring-blue-500">
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                            Detailed Description
                        </label>
                        <div className="mt-2 hovercl">
                            <WYWSGI
                                setParent={setMessage}
                                placeholder="Please provide a detailed description of your issue or query here. The more information you can provide, the better we can assist you."
                            />
                        </div>
                    </div>
                    <div className="mt-6 text-right">
                        <button
                            type="button"
                            onClick={raiseTicket}
                            disabled={loading}
                            className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            {loading ? <InlineLoader /> : "Submit"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default NewSupport;